import { render, staticRenderFns } from "./Baomingjilu.vue?vue&type=template&id=79c197d2&"
import script from "./Baomingjilu.vue?vue&type=script&lang=js&"
export * from "./Baomingjilu.vue?vue&type=script&lang=js&"
import style0 from "./Baomingjilu.vue?vue&type=style&index=0&id=79c197d2&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports